const getBoxes = state => state.boxes;
const getCountBoxes = state => state.countBoxes;
const getBoxesInClient = state => state.boxesInClient;
const getBoxesMasivo = state => state.boxesMasivo;

export default {
  getBoxes,
  getCountBoxes,
  getBoxesInClient,
  getBoxesMasivo
};



// WEBPACK FOOTER //
// ./src/store/modules/boxes/getters.js